import {
  fetchDelete,
  fetchGet,
  fetchPost,
  fetchPut,
  toQueryString,
} from "../../../service/api_client";

export interface TransformLine {
  item_code: string;
  item_name: string;
  qty: number;
}

export enum TransformApprovalStatus {
  PENDING = "Pending Approval",
  APPROVED = "Approved",
  REJECTED = "Rejected",
}

export interface TransformMasterModel {
  id?: string;
  inputs: TransformLine[];
  outputs: TransformLine[];
  remarks?: string;
  created_at?: string;
  created_by_name?: string;
  approval_status?: TransformApprovalStatus;
  submitted_by?: string;
  submitted_by_name?: string;
  approved_by_name?: string;
  approved_at?: string;
  rejected_by_name?: string;
  rejected_at?: string;
  rejected_reason?: string;
}

const BASE = `${process.env.REACT_APP_BACKEND_BASE_URL}/api/v3/erp/inventory/transform-master`;

export const CreateTransformMasterApi = async (data: TransformMasterModel) => {
  try {
    return await fetchPost(`${BASE}`, data);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const UpdateTransformMasterApi = async (
  id: string,
  data: TransformMasterModel,
) => {
  try {
    return await fetchPut(`${BASE}/${id}`, data);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const ApproveTransformMasterApi = async (id: string) => {
  try {
    return await fetchPut(`${BASE}/${id}/approve`, {});
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const RejectTransformMasterApi = async (id: string, reason: string) => {
  try {
    return await fetchPut(`${BASE}/${id}/reject`, { reason });
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetTransformMastersApi = async (option: {
  page?: number;
  count?: number;
  all?: boolean;
  search?: string;
  approval_status?: TransformApprovalStatus;
}) => {
  try {
    return await fetchGet(`${BASE}${toQueryString(option)}`);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const GetTransformMasterByIdApi = async (id: string) => {
  try {
    return await fetchGet(`${BASE}/${id}`);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

export const DeleteTransformMasterApi = async (id: string) => {
  try {
    return await fetchDelete(`${BASE}/${id}`);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

// Distinct items that participate in any transform (either side) — used to
// restrict the Item Code Transfer source picker.
export const GetTransformableItemsApi = async () => {
  try {
    return await fetchGet(`${BASE}/transformable-items`);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};

// All transforms that involve the given item on either side.
export const GetTransformsForItemApi = async (item_code: string) => {
  try {
    return await fetchGet(`${BASE}/for-item/${encodeURIComponent(item_code)}`);
  } catch (error: any) {
    return { success: false, error: error.message };
  }
};
